import Analytics from 'analytics'
import matomoPlugin from './Matomo'

let domain = window.location.hostname
// check for local or staging environment
if (
  window.location.toString().indexOf('localhost') !== -1 ||
  window.location.toString().indexOf('lvh') !== -1 ||
  window.location.toString().indexOf('newsummit') !== -1 ||
  window.location.toString().indexOf('wpengine') !== -1 ||
  window.location.toString().indexOf('vercel') !== -1
) {
  domain = 'summitengine.com'
}

const matomo = matomoPlugin({
  enabled: true,
  url: `https://tracking.${domain}/`
})

const masterAnalytics = Analytics({
  app: 'blueprint',
  plugins: [matomo]
})

export const handleAnalyticsEvent = (action, category, label) => {
  masterAnalytics.track('trackEvent', {
    action: action || 'defaultAction',
    category: category || 'defaultCategory',
    label
  })
}

export const handleAnalyticsGoal = goalId => {
  window._paq.push(['trackGoal', goalId])
}

export default masterAnalytics
